module.exports = __webpack_public_path__ + "static/media/simplified-task-management.dca55a89.svg";